import axios from 'axios';

// const Conect = axios.create({ baseURL: 'http://192.168.100.5:3000' });
// const Conect = axios.create({ baseURL: 'http://localhost:5436' });
const Conect = axios.create({ baseURL: 'https://sakamottosann.com.br/api3' });

export default Conect;